export default __webpack_public_path__ + "static/media/IMG_4568-min.0626666e.JPG";